import { render } from "./index.vue?vue&type=template&id=175a08b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=175a08b6&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-175a08b6"

export default script